
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404rIGuF9ca_lH_CeIGaWkA5M7FdhM1FXOpKbuBfD5dqmAMeta } from "/usr/src/nuxtapp/app/pages/sbe/404.vue?macro=true";
import { default as faqqNAz_d1oJ3DLrGLzDf_ry9k1meD8qaD2UXPopTbW05IMeta } from "/usr/src/nuxtapp/app/pages/sbe/faq.vue?macro=true";
import { default as indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta } from "/usr/src/nuxtapp/app/pages/sbe/index.vue?macro=true";
import { default as logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta } from "/usr/src/nuxtapp/app/pages/sbe/login.vue?macro=true";
import { default as logoutnBTiNauxuVmcvQd4FewARiobVo_meEjdF_OWSEDCb7EMeta } from "/usr/src/nuxtapp/app/pages/sbe/logout.vue?macro=true";
import { default as search55D1KpSsyywTCtHkHVtEEwHTQJTvlCiBNja9nbGHRekMeta } from "/usr/src/nuxtapp/app/pages/sbe/search.vue?macro=true";
import { default as index9ZVjZVUp5k_DntpB7OktC4cLLlbejq1bcrOzI4leJzkMeta } from "/usr/src/nuxtapp/app/pages/sbe/blog/index.vue?macro=true";
import { default as contact_45usqu1LtugsKM_T1U_Bbs9lkHs7JbyY8_k_emi47Pkgu2cMeta } from "/usr/src/nuxtapp/app/pages/sbe/contact-us.vue?macro=true";
import { default as sellkdE5r_PHnHDygJkQIHblBvHhZoRTAYtoMU8IuGGk5KYMeta } from "/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue?macro=true";
import { default as _91code_93486pGUdckWXjISBkLdVBzSsudZvTXdsGw4XMx10enCAMeta } from "/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue?macro=true";
import { default as indexUhsEvDAw4brWl1AnaA_KWFE7aDYOtGqfIfcDL0OSjhQMeta } from "/usr/src/nuxtapp/app/pages/sbe/charts/index.vue?macro=true";
import { default as _91code_93ERp_N_g9Id2DNnwyBFkEJ2Pajzu96FElduhyApSPcj4Meta } from "/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue?macro=true";
import { default as indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/index.vue?macro=true";
import { default as indexZ44HubxMLTLvG9hh8fd2MGAveWDBJuNJFO16HMcehawMeta } from "/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue?macro=true";
import { default as index0gCI4HN3KdUjdazic2tAIW9BL6TiCl1OB19360lAYM0Meta } from "/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue?macro=true";
import { default as ledger7Mp19Yge8UevQsoT4ap2J3xoqcsb6xshcNanampZUpQMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue?macro=true";
import { default as ordersWEpTBZMnsI0gg_9sBVkaSDh92XEiRuIs6D5C2pcuc2wMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue?macro=true";
import { default as indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta } from "/usr/src/nuxtapp/app/pages/sbe/register/index.vue?macro=true";
import { default as _91code_93q7MS0YaEgPGfZSi6B_OJWrEtdAXLuzFw4ccaQzFjtJUMeta } from "/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue?macro=true";
import { default as _91code_93z99I_YGgfZQUb724x8ogG8gtwa8rYgalzY5iY3YtLSUMeta } from "/usr/src/nuxtapp/app/pages/sbe/register/[code].vue?macro=true";
import { default as paymentPnPZF6B14zXsoeN3H_dg_mTqQ7MYAGl7JFVgvqhVEhQMeta } from "/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue?macro=true";
import { default as _91code_93x35dL7uc5bSfl_VzUpH4_MqEhixYPxxIItgdD7QZ8OsMeta } from "/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue?macro=true";
import { default as invoicesiO8uxnu1SvaWcmYHfZmRB2m5uB_2l_J0_nwUT0pDGh4Meta } from "/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue?macro=true";
import { default as resellersJ7cnDN998hDfmi_B7tMzc3D3GsNFpNtTHM389cwaZcMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue?macro=true";
import { default as successEDaxf2mH5qUpmx91eRVp_4fAIy8_AE0fRC5XAdQpoUoMeta } from "/usr/src/nuxtapp/app/pages/sbe/register/success.vue?macro=true";
import { default as complete3KWn7tibY9cb1JclKtWHVw9mNM_lB2URpSGa6iqrrJgMeta } from "/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue?macro=true";
import { default as shippingmeH9lg6l6wUCO_WnXN0rnqKXVe7BBe4PVTZALyoMglMMeta } from "/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue?macro=true";
import { default as addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta } from "/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue?macro=true";
import { default as referralsjC0MiAPfIOhWeGeSkV_E2_JyqvWxLXq2fTCKcFpjo40Meta } from "/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue?macro=true";
import { default as watchlistG1B1_lXtaMWeM_cmBGjXW3l2JUJMgbarcc_0TpMnt_YMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue?macro=true";
import { default as _91_46_46_46slug_93KAUoSSRHofzREoqaCtTui6RZOsfqOvQGWEioDzXTXtQMeta } from "/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue?macro=true";
import { default as investmentVrup5qb3dnbMvmj35S66UEVUlZxpxNjjqL7g1mEyBPsMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue?macro=true";
import { default as indexsvBvbPXNW5WWZMtdRvw7VueiEdUAC_UwqoEGtzf9sCQMeta } from "/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue?macro=true";
import { default as sell_45orders8jhw7V6eqv_mf7LKOXGDS027Ts7_xirdVQy0oUqD5gcMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue?macro=true";
import { default as subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta } from "/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue?macro=true";
import { default as expireduYcmVj66_KAWNvNbtFZQLlTxNvqk_mp_f52PPFtgFYAMeta } from "/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue?macro=true";
import { default as completedZUPGdqdOBsXjGhZcPwvFN0wBJYEOCcNMV2VGL2ksvKYMeta } from "/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue?macro=true";
import { default as shipping_45pricesYsnqGyGiTPNOxH1CJxIp5wjwtWbOWZ7xDhjbedWDe8IMeta } from "/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue?macro=true";
import { default as indexcU_yTFAXrVN_bx1Axe6_hjttAjOQ2YQBiHPzeej_ZxwMeta } from "/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue?macro=true";
import { default as _91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta } from "/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue?macro=true";
import { default as completed0_XIIFkc_A9RUQ4GBkh3m79IQCxzZTfza_HOtKn49LAMeta } from "/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue?macro=true";
import { default as unsubscribeZEN4ZD28CP0jBOCcypJUXapKiB2XsnNQzdjPgklnKRQMeta } from "/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue?macro=true";
import { default as _91code_93x_YI2mzUpwue3_DrLn1wuxUU_107nLUFgsz8ttcUnwIMeta } from "/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue?macro=true";
import { default as indexDbCl23_ILK3IhsUr1FhP_V6FBc1LYToddcn05KmRgDgMeta } from "/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue?macro=true";
import { default as index3p_OL3ec2yb0lTXOyaggNYGXXfhbQYRctXLwEktzgX0Meta } from "/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue?macro=true";
import { default as index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta } from "~/pages/spm/trade/sell/index.vue?macro=true";
import { default as reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta } from "~/pages/spm/trade/review.vue?macro=true";
import { default as review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta } from "~/pages/spm/trade/sell/review.vue?macro=true";
import { default as completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta } from "~/pages/spm/trade/complete.vue?macro=true";
import { default as completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta } from "~/pages/spm/trade/sell/complete.vue?macro=true";
export default [
  {
    name: "404___en",
    path: "/en/404",
    meta: {"middleware":"page-404"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/404.vue")
  },
  {
    name: "404___es",
    path: "/es/404",
    meta: {"middleware":"page-404"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/404.vue")
  },
  {
    name: "404___fr",
    path: "/fr/404",
    meta: {"middleware":"page-404"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/404.vue")
  },
  {
    name: "404___it",
    path: "/it/404",
    meta: {"middleware":"page-404"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/404.vue")
  },
  {
    name: "404___ru",
    path: "/ru/404",
    meta: {"middleware":"page-404"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/404.vue")
  },
  {
    name: "404___de",
    path: "/de/404",
    meta: {"middleware":"page-404"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/404.vue")
  },
  {
    name: "404___pl",
    path: "/pl/404",
    meta: {"middleware":"page-404"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/404.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    meta: {"middleware":"page-faq"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    meta: {"middleware":"page-faq"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/faq.vue")
  },
  {
    name: "faq___fr",
    path: "/fr/faq",
    meta: {"middleware":"page-faq"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/faq.vue")
  },
  {
    name: "faq___it",
    path: "/it/faq",
    meta: {"middleware":"page-faq"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    meta: {"middleware":"page-faq"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/faq.vue")
  },
  {
    name: "faq___de",
    path: "/de/faq",
    meta: {"middleware":"page-faq"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/faq.vue")
  },
  {
    name: "faq___pl",
    path: "/pl/faq",
    meta: {"middleware":"page-faq"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/faq.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: { ...(indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta || {}), ...{"middleware":["permission","page-index","page-trade"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: { ...(indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta || {}), ...{"middleware":["permission","page-index","page-trade"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: { ...(indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta || {}), ...{"middleware":["permission","page-index","page-trade"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: { ...(indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta || {}), ...{"middleware":["permission","page-index","page-trade"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: { ...(indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta || {}), ...{"middleware":["permission","page-index","page-trade"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: { ...(indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta || {}), ...{"middleware":["permission","page-index","page-trade"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: { ...(indexRPtRSotnyfjEwaLlHA946KDMAvYhRRIcGQdjVDOsA4oMeta || {}), ...{"middleware":["permission","page-index","page-trade"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: { ...(logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta || {}), ...{"middleware":"page-login"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/login.vue")
  },
  {
    name: "login___es",
    path: "/es/iniciar-sesion",
    meta: { ...(logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta || {}), ...{"middleware":"page-login"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/connexion",
    meta: { ...(logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta || {}), ...{"middleware":"page-login"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/login.vue")
  },
  {
    name: "login___it",
    path: "/it/accedi",
    meta: { ...(logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta || {}), ...{"middleware":"page-login"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login",
    meta: { ...(logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta || {}), ...{"middleware":"page-login"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/login.vue")
  },
  {
    name: "login___de",
    path: "/de/anmeldung",
    meta: { ...(logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta || {}), ...{"middleware":"page-login"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/login.vue")
  },
  {
    name: "login___pl",
    path: "/pl/logowanie",
    meta: { ...(logini4JDkpV9aPvqwE4_iY3_rcy68iLvO4odOuA1biHcLYgMeta || {}), ...{"middleware":"page-login"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/login.vue")
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: {"middleware":["auth","page-logout"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/logout.vue")
  },
  {
    name: "logout___es",
    path: "/es/logout",
    meta: {"middleware":["auth","page-logout"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/logout.vue")
  },
  {
    name: "logout___fr",
    path: "/fr/logout",
    meta: {"middleware":["auth","page-logout"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/logout.vue")
  },
  {
    name: "logout___it",
    path: "/it/logout",
    meta: {"middleware":["auth","page-logout"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/logout.vue")
  },
  {
    name: "logout___ru",
    path: "/ru/logout",
    meta: {"middleware":["auth","page-logout"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/logout.vue")
  },
  {
    name: "logout___de",
    path: "/de/logout",
    meta: {"middleware":["auth","page-logout"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: {"middleware":["auth","page-logout"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/logout.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: {"middleware":["page-search","catalog-pagination"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/search.vue")
  },
  {
    name: "search___es",
    path: "/es/search",
    meta: {"middleware":["page-search","catalog-pagination"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    meta: {"middleware":["page-search","catalog-pagination"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/search.vue")
  },
  {
    name: "search___it",
    path: "/it/search",
    meta: {"middleware":["page-search","catalog-pagination"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/search.vue")
  },
  {
    name: "search___ru",
    path: "/ru/search",
    meta: {"middleware":["page-search","catalog-pagination"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    meta: {"middleware":["page-search","catalog-pagination"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/search.vue")
  },
  {
    name: "search___pl",
    path: "/pl/search",
    meta: {"middleware":["page-search","catalog-pagination"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/search.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/index.vue")
  },
  {
    name: "blog___pl",
    path: "/pl/blog",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/index.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/contact-us.vue")
  },
  {
    name: "contact-us___es",
    path: "/es/contactanos",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/contact-us.vue")
  },
  {
    name: "contact-us___fr",
    path: "/fr/contactez-nous",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/contact-us.vue")
  },
  {
    name: "contact-us___it",
    path: "/it/contattaci",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/contact-us.vue")
  },
  {
    name: "contact-us___ru",
    path: "/ru/contact-us",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/contact-us.vue")
  },
  {
    name: "contact-us___de",
    path: "/de/kontaktieren-sie-uns",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/contact-us.vue")
  },
  {
    name: "contact-us___pl",
    path: "/pl/kontakt",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/contact-us.vue")
  },
  {
    name: "trade-sell___en",
    path: "/en/trade/sell",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue")
  },
  {
    name: "trade-sell___es",
    path: "/es/trade/sell",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue")
  },
  {
    name: "trade-sell___fr",
    path: "/fr/trade/sell",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue")
  },
  {
    name: "trade-sell___it",
    path: "/it/trade/sell",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue")
  },
  {
    name: "trade-sell___ru",
    path: "/ru/trade/sell",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue")
  },
  {
    name: "trade-sell___de",
    path: "/de/trade/sell",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue")
  },
  {
    name: "trade-sell___pl",
    path: "/pl/trade/sell",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/trade/sell.vue")
  },
  {
    name: "blog-code___en",
    path: "/en/blog/:code()",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue")
  },
  {
    name: "blog-code___es",
    path: "/es/blog/:code()",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue")
  },
  {
    name: "blog-code___fr",
    path: "/fr/blog/:code()",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue")
  },
  {
    name: "blog-code___it",
    path: "/it/blog/:code()",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue")
  },
  {
    name: "blog-code___ru",
    path: "/ru/blog/:code()",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue")
  },
  {
    name: "blog-code___de",
    path: "/de/blog/:code()",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue")
  },
  {
    name: "blog-code___pl",
    path: "/pl/blog/:code()",
    meta: {"middleware":["page-blog"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/blog/[code].vue")
  },
  {
    name: "charts___en",
    path: "/en/charts",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/index.vue")
  },
  {
    name: "charts___es",
    path: "/es/graficos",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/index.vue")
  },
  {
    name: "charts___fr",
    path: "/fr/graphiques",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/index.vue")
  },
  {
    name: "charts___it",
    path: "/it/grafici",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/index.vue")
  },
  {
    name: "charts___ru",
    path: "/ru/charts",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/index.vue")
  },
  {
    name: "charts___de",
    path: "/de/kurse",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/index.vue")
  },
  {
    name: "charts___pl",
    path: "/pl/wykresy",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/index.vue")
  },
  {
    name: "pages-code___en",
    path: "/en/pages/:code()",
    meta: {"middleware":"page-content"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue")
  },
  {
    name: "pages-code___es",
    path: "/es/paginas/:code()",
    meta: {"middleware":"page-content"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue")
  },
  {
    name: "pages-code___fr",
    path: "/fr/pages/:code()",
    meta: {"middleware":"page-content"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue")
  },
  {
    name: "pages-code___it",
    path: "/it/pagine/:code()",
    meta: {"middleware":"page-content"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue")
  },
  {
    name: "pages-code___ru",
    path: "/ru/pages/:code()",
    meta: {"middleware":"page-content"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue")
  },
  {
    name: "pages-code___de",
    path: "/de/seiten/:code()",
    meta: {"middleware":"page-content"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue")
  },
  {
    name: "pages-code___pl",
    path: "/pl/strony/:code()",
    meta: {"middleware":"page-content"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/[code].vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: { ...(indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta || {}), ...{"middleware":["auth","permission","page-profile"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/index.vue")
  },
  {
    name: "profile___es",
    path: "/es/profile",
    meta: { ...(indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta || {}), ...{"middleware":["auth","permission","page-profile"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/index.vue")
  },
  {
    name: "profile___fr",
    path: "/fr/profile",
    meta: { ...(indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta || {}), ...{"middleware":["auth","permission","page-profile"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/index.vue")
  },
  {
    name: "profile___it",
    path: "/it/profile",
    meta: { ...(indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta || {}), ...{"middleware":["auth","permission","page-profile"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/index.vue")
  },
  {
    name: "profile___ru",
    path: "/ru/profile",
    meta: { ...(indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta || {}), ...{"middleware":["auth","permission","page-profile"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/index.vue")
  },
  {
    name: "profile___de",
    path: "/de/profile",
    meta: { ...(indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta || {}), ...{"middleware":["auth","permission","page-profile"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/index.vue")
  },
  {
    name: "profile___pl",
    path: "/pl/profile",
    meta: { ...(indexsNwwFqgxFwEnjn51f9_LnzFhtfoXv3QLDocWoh2GDCUMeta || {}), ...{"middleware":["auth","permission","page-profile"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/index.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    meta: {"middleware":"page-cart"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue")
  },
  {
    name: "checkout___es",
    path: "/es/checkout",
    meta: {"middleware":"page-cart"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: {"middleware":"page-cart"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue")
  },
  {
    name: "checkout___it",
    path: "/it/checkout",
    meta: {"middleware":"page-cart"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue")
  },
  {
    name: "checkout___ru",
    path: "/ru/checkout",
    meta: {"middleware":"page-cart"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue")
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    meta: {"middleware":"page-cart"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue")
  },
  {
    name: "checkout___pl",
    path: "/pl/checkout",
    meta: {"middleware":"page-cart"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/index.vue")
  },
  {
    name: "glossary___en",
    path: "/en/glossary",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue")
  },
  {
    name: "glossary___es",
    path: "/es/glosario",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue")
  },
  {
    name: "glossary___fr",
    path: "/fr/glossaire",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue")
  },
  {
    name: "glossary___it",
    path: "/it/glossario",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue")
  },
  {
    name: "glossary___ru",
    path: "/ru/glossary",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue")
  },
  {
    name: "glossary___de",
    path: "/de/lexikon",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue")
  },
  {
    name: "glossary___pl",
    path: "/pl/slownik",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/index.vue")
  },
  {
    name: "profile-ledger___en",
    path: "/en/profile/ledger",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue")
  },
  {
    name: "profile-ledger___es",
    path: "/es/profile/ledger",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue")
  },
  {
    name: "profile-ledger___fr",
    path: "/fr/profile/ledger",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue")
  },
  {
    name: "profile-ledger___it",
    path: "/it/profile/ledger",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue")
  },
  {
    name: "profile-ledger___ru",
    path: "/ru/profile/ledger",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue")
  },
  {
    name: "profile-ledger___de",
    path: "/de/profile/ledger",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue")
  },
  {
    name: "profile-ledger___pl",
    path: "/pl/profile/ledger",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/ledger.vue")
  },
  {
    name: "profile-orders___en",
    path: "/en/profile/orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue")
  },
  {
    name: "profile-orders___es",
    path: "/es/profile/orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue")
  },
  {
    name: "profile-orders___fr",
    path: "/fr/profile/orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue")
  },
  {
    name: "profile-orders___it",
    path: "/it/profile/orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue")
  },
  {
    name: "profile-orders___ru",
    path: "/ru/profile/orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue")
  },
  {
    name: "profile-orders___de",
    path: "/de/profile/orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue")
  },
  {
    name: "profile-orders___pl",
    path: "/pl/profile/orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/orders.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: { ...(indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta || {}), ...{"middleware":["guest","page-register"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/index.vue")
  },
  {
    name: "register___es",
    path: "/es/registro",
    meta: { ...(indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta || {}), ...{"middleware":["guest","page-register"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/index.vue")
  },
  {
    name: "register___fr",
    path: "/fr/inscription",
    meta: { ...(indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta || {}), ...{"middleware":["guest","page-register"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/index.vue")
  },
  {
    name: "register___it",
    path: "/it/registrazione",
    meta: { ...(indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta || {}), ...{"middleware":["guest","page-register"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/index.vue")
  },
  {
    name: "register___ru",
    path: "/ru/register",
    meta: { ...(indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta || {}), ...{"middleware":["guest","page-register"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/index.vue")
  },
  {
    name: "register___de",
    path: "/de/registrieren",
    meta: { ...(indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta || {}), ...{"middleware":["guest","page-register"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/index.vue")
  },
  {
    name: "register___pl",
    path: "/pl/rejestracja",
    meta: { ...(indexMM2Qxfq5nw6dkbTzJy_8LdM9PdYcgmjTrrg5t7c0Ba4Meta || {}), ...{"middleware":["guest","page-register"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/index.vue")
  },
  {
    name: "glossary-code___en",
    path: "/en/glossary/:code()",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue")
  },
  {
    name: "glossary-code___es",
    path: "/es/glosario/:code()",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue")
  },
  {
    name: "glossary-code___fr",
    path: "/fr/glossaire/:code()",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue")
  },
  {
    name: "glossary-code___it",
    path: "/it/glossario/:code()",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue")
  },
  {
    name: "glossary-code___ru",
    path: "/ru/glossary/:code()",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue")
  },
  {
    name: "glossary-code___de",
    path: "/de/lexikon/:code()",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue")
  },
  {
    name: "glossary-code___pl",
    path: "/pl/slownik/:code()",
    meta: {"middleware":["page-glossary"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/glossary/[code].vue")
  },
  {
    name: "register-code___en",
    path: "/en/register/:code()",
    meta: {"middleware":["guest","page-register"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/[code].vue")
  },
  {
    name: "register-code___es",
    path: "/es/registro/:code()",
    meta: {"middleware":["guest","page-register"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/[code].vue")
  },
  {
    name: "register-code___fr",
    path: "/fr/inscription/:code()",
    meta: {"middleware":["guest","page-register"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/[code].vue")
  },
  {
    name: "register-code___it",
    path: "/it/registrazione/:code()",
    meta: {"middleware":["guest","page-register"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/[code].vue")
  },
  {
    name: "register-code___ru",
    path: "/ru/register/:code()",
    meta: {"middleware":["guest","page-register"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/[code].vue")
  },
  {
    name: "register-code___de",
    path: "/de/registrieren/:code()",
    meta: {"middleware":["guest","page-register"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/[code].vue")
  },
  {
    name: "register-code___pl",
    path: "/pl/rejestracja/:code()",
    meta: {"middleware":["guest","page-register"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/[code].vue")
  },
  {
    name: "checkout-payment___en",
    path: "/en/checkout/payment",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue")
  },
  {
    name: "checkout-payment___es",
    path: "/es/checkout/payment",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue")
  },
  {
    name: "checkout-payment___fr",
    path: "/fr/checkout/payment",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue")
  },
  {
    name: "checkout-payment___it",
    path: "/it/checkout/payment",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue")
  },
  {
    name: "checkout-payment___ru",
    path: "/ru/checkout/payment",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue")
  },
  {
    name: "checkout-payment___de",
    path: "/de/checkout/payment",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue")
  },
  {
    name: "checkout-payment___pl",
    path: "/pl/checkout/payment",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/payment.vue")
  },
  {
    name: "documents-code___en",
    path: "/en/documents/:code()",
    meta: {"middleware":"page-documents"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue")
  },
  {
    name: "documents-code___es",
    path: "/es/documentos/:code()",
    meta: {"middleware":"page-documents"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue")
  },
  {
    name: "documents-code___fr",
    path: "/fr/documents/:code()",
    meta: {"middleware":"page-documents"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue")
  },
  {
    name: "documents-code___it",
    path: "/it/documenti/:code()",
    meta: {"middleware":"page-documents"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue")
  },
  {
    name: "documents-code___ru",
    path: "/ru/documents/:code()",
    meta: {"middleware":"page-documents"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue")
  },
  {
    name: "documents-code___de",
    path: "/de/dokumente/:code()",
    meta: {"middleware":"page-documents"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue")
  },
  {
    name: "documents-code___pl",
    path: "/pl/dokumenty/:code()",
    meta: {"middleware":"page-documents"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/documents/[code].vue")
  },
  {
    name: "profile-invoices___en",
    path: "/en/profile/invoices",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue")
  },
  {
    name: "profile-invoices___es",
    path: "/es/profile/invoices",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue")
  },
  {
    name: "profile-invoices___fr",
    path: "/fr/profile/invoices",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue")
  },
  {
    name: "profile-invoices___it",
    path: "/it/profile/invoices",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue")
  },
  {
    name: "profile-invoices___ru",
    path: "/ru/profile/invoices",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue")
  },
  {
    name: "profile-invoices___de",
    path: "/de/profile/invoices",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue")
  },
  {
    name: "profile-invoices___pl",
    path: "/pl/profile/invoices",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/invoices.vue")
  },
  {
    name: "profile-reseller___en",
    path: "/en/profile/reseller",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue")
  },
  {
    name: "profile-reseller___es",
    path: "/es/profile/reseller",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue")
  },
  {
    name: "profile-reseller___fr",
    path: "/fr/profile/reseller",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue")
  },
  {
    name: "profile-reseller___it",
    path: "/it/profile/reseller",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue")
  },
  {
    name: "profile-reseller___ru",
    path: "/ru/profile/reseller",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue")
  },
  {
    name: "profile-reseller___de",
    path: "/de/profile/reseller",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue")
  },
  {
    name: "profile-reseller___pl",
    path: "/pl/profile/reseller",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/reseller.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    meta: {"middleware":"guest"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/success.vue")
  },
  {
    name: "register-success___es",
    path: "/es/registro/completado",
    meta: {"middleware":"guest"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/success.vue")
  },
  {
    name: "register-success___fr",
    path: "/fr/inscription/termine",
    meta: {"middleware":"guest"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/success.vue")
  },
  {
    name: "register-success___it",
    path: "/it/registrazione/completata",
    meta: {"middleware":"guest"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/success.vue")
  },
  {
    name: "register-success___ru",
    path: "/ru/register/success",
    meta: {"middleware":"guest"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/success.vue")
  },
  {
    name: "register-success___de",
    path: "/de/registrieren/abgeschlossen",
    meta: {"middleware":"guest"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/rejestracja/zako%C5%84czona",
    meta: {"middleware":"guest"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/success.vue")
  },
  {
    name: "checkout-complete___en",
    path: "/en/checkout/complete",
    meta: {"middleware":"page-complete"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue")
  },
  {
    name: "checkout-complete___es",
    path: "/es/checkout/complete",
    meta: {"middleware":"page-complete"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue")
  },
  {
    name: "checkout-complete___fr",
    path: "/fr/checkout/complete",
    meta: {"middleware":"page-complete"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue")
  },
  {
    name: "checkout-complete___it",
    path: "/it/checkout/complete",
    meta: {"middleware":"page-complete"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue")
  },
  {
    name: "checkout-complete___ru",
    path: "/ru/checkout/complete",
    meta: {"middleware":"page-complete"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue")
  },
  {
    name: "checkout-complete___de",
    path: "/de/checkout/complete",
    meta: {"middleware":"page-complete"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue")
  },
  {
    name: "checkout-complete___pl",
    path: "/pl/checkout/complete",
    meta: {"middleware":"page-complete"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/complete.vue")
  },
  {
    name: "checkout-shipping___en",
    path: "/en/checkout/shipping",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___es",
    path: "/es/checkout/shipping",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___fr",
    path: "/fr/checkout/shipping",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___it",
    path: "/it/checkout/shipping",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___ru",
    path: "/ru/checkout/shipping",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___de",
    path: "/de/checkout/shipping",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___pl",
    path: "/pl/checkout/shipping",
    meta: {"middleware":"page-checkout"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/checkout/shipping.vue")
  },
  {
    name: "profile-addresses___en",
    path: "/en/profile/addresses",
    meta: { ...(addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue")
  },
  {
    name: "profile-addresses___es",
    path: "/es/profile/addresses",
    meta: { ...(addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue")
  },
  {
    name: "profile-addresses___fr",
    path: "/fr/profile/addresses",
    meta: { ...(addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue")
  },
  {
    name: "profile-addresses___it",
    path: "/it/profile/addresses",
    meta: { ...(addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue")
  },
  {
    name: "profile-addresses___ru",
    path: "/ru/profile/addresses",
    meta: { ...(addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue")
  },
  {
    name: "profile-addresses___de",
    path: "/de/profile/addresses",
    meta: { ...(addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue")
  },
  {
    name: "profile-addresses___pl",
    path: "/pl/profile/addresses",
    meta: { ...(addressesBZIV39BDJK9MTkKEjPuXNgpM8Iqg_7Bj48tc4H1_7b4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/addresses.vue")
  },
  {
    name: "profile-referrals___en",
    path: "/en/profile/referrals",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue")
  },
  {
    name: "profile-referrals___es",
    path: "/es/profile/referrals",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue")
  },
  {
    name: "profile-referrals___fr",
    path: "/fr/profile/referrals",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue")
  },
  {
    name: "profile-referrals___it",
    path: "/it/profile/referrals",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue")
  },
  {
    name: "profile-referrals___ru",
    path: "/ru/profile/referrals",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue")
  },
  {
    name: "profile-referrals___de",
    path: "/de/profile/referrals",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue")
  },
  {
    name: "profile-referrals___pl",
    path: "/pl/profile/referrals",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/referrals.vue")
  },
  {
    name: "profile-watchlist___en",
    path: "/en/profile/watchlist",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue")
  },
  {
    name: "profile-watchlist___es",
    path: "/es/profile/watchlist",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue")
  },
  {
    name: "profile-watchlist___fr",
    path: "/fr/profile/watchlist",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue")
  },
  {
    name: "profile-watchlist___it",
    path: "/it/profile/watchlist",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue")
  },
  {
    name: "profile-watchlist___ru",
    path: "/ru/profile/watchlist",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue")
  },
  {
    name: "profile-watchlist___de",
    path: "/de/profile/watchlist",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue")
  },
  {
    name: "profile-watchlist___pl",
    path: "/pl/profile/watchlist",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/watchlist.vue")
  },
  {
    name: "locale-slug___en",
    path: "/en/:locale()/:slug(.*)*",
    meta: {"middleware":["page-router","catalog-pagination","language-redirect"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue")
  },
  {
    name: "locale-slug___es",
    path: "/es/:locale()/:slug(.*)*",
    meta: {"middleware":["page-router","catalog-pagination","language-redirect"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue")
  },
  {
    name: "locale-slug___fr",
    path: "/fr/:locale()/:slug(.*)*",
    meta: {"middleware":["page-router","catalog-pagination","language-redirect"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue")
  },
  {
    name: "locale-slug___it",
    path: "/it/:locale()/:slug(.*)*",
    meta: {"middleware":["page-router","catalog-pagination","language-redirect"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue")
  },
  {
    name: "locale-slug___ru",
    path: "/ru/:locale()/:slug(.*)*",
    meta: {"middleware":["page-router","catalog-pagination","language-redirect"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue")
  },
  {
    name: "locale-slug___de",
    path: "/de/:locale()/:slug(.*)*",
    meta: {"middleware":["page-router","catalog-pagination","language-redirect"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue")
  },
  {
    name: "locale-slug___pl",
    path: "/pl/:locale()/:slug(.*)*",
    meta: {"middleware":["page-router","catalog-pagination","language-redirect"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/[locale]/[...slug].vue")
  },
  {
    name: "profile-investment___en",
    path: "/en/profile/investment",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue")
  },
  {
    name: "profile-investment___es",
    path: "/es/profile/investment",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue")
  },
  {
    name: "profile-investment___fr",
    path: "/fr/profile/investment",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue")
  },
  {
    name: "profile-investment___it",
    path: "/it/profile/investment",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue")
  },
  {
    name: "profile-investment___ru",
    path: "/ru/profile/investment",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue")
  },
  {
    name: "profile-investment___de",
    path: "/de/profile/investment",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue")
  },
  {
    name: "profile-investment___pl",
    path: "/pl/profile/investment",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/investment.vue")
  },
  {
    name: "charts-code___en",
    path: "/en/charts/:code()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue")
  },
  {
    name: "charts-code___es",
    path: "/es/graficos/:code()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue")
  },
  {
    name: "charts-code___fr",
    path: "/fr/graphiques/:code()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue")
  },
  {
    name: "charts-code___it",
    path: "/it/grafici/:code()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue")
  },
  {
    name: "charts-code___ru",
    path: "/ru/charts/:code()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue")
  },
  {
    name: "charts-code___de",
    path: "/de/kurse/:code()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue")
  },
  {
    name: "charts-code___pl",
    path: "/pl/wykresy/:code()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/index.vue")
  },
  {
    name: "profile-sell-orders___en",
    path: "/en/profile/sell-orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue")
  },
  {
    name: "profile-sell-orders___es",
    path: "/es/profile/sell-orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue")
  },
  {
    name: "profile-sell-orders___fr",
    path: "/fr/profile/sell-orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue")
  },
  {
    name: "profile-sell-orders___it",
    path: "/it/profile/sell-orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue")
  },
  {
    name: "profile-sell-orders___ru",
    path: "/ru/profile/sell-orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue")
  },
  {
    name: "profile-sell-orders___de",
    path: "/de/profile/sell-orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue")
  },
  {
    name: "profile-sell-orders___pl",
    path: "/pl/profile/sell-orders",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/sell-orders.vue")
  },
  {
    name: "profile-subaccounts___en",
    path: "/en/profile/subaccounts",
    meta: { ...(subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue")
  },
  {
    name: "profile-subaccounts___es",
    path: "/es/profile/subaccounts",
    meta: { ...(subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue")
  },
  {
    name: "profile-subaccounts___fr",
    path: "/fr/profile/subaccounts",
    meta: { ...(subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue")
  },
  {
    name: "profile-subaccounts___it",
    path: "/it/profile/subaccounts",
    meta: { ...(subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue")
  },
  {
    name: "profile-subaccounts___ru",
    path: "/ru/profile/subaccounts",
    meta: { ...(subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue")
  },
  {
    name: "profile-subaccounts___de",
    path: "/de/profile/subaccounts",
    meta: { ...(subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue")
  },
  {
    name: "profile-subaccounts___pl",
    path: "/pl/profile/subaccounts",
    meta: { ...(subaccountsr6XWDAzYP0MBSWtPbXPAWHPdcFa6lEijy_eR9ycpTMgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/profile/subaccounts.vue")
  },
  {
    name: "subaccounts-expired___en",
    path: "/en/subaccounts/expired",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue")
  },
  {
    name: "subaccounts-expired___es",
    path: "/es/subaccounts/expired",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue")
  },
  {
    name: "subaccounts-expired___fr",
    path: "/fr/subaccounts/expired",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue")
  },
  {
    name: "subaccounts-expired___it",
    path: "/it/subaccounts/expired",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue")
  },
  {
    name: "subaccounts-expired___ru",
    path: "/ru/subaccounts/expired",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue")
  },
  {
    name: "subaccounts-expired___de",
    path: "/de/subaccounts/expired",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue")
  },
  {
    name: "subaccounts-expired___pl",
    path: "/pl/subaccounts/expired",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/expired.vue")
  },
  {
    name: "newsletter-completed___en",
    path: "/en/newsletter/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue")
  },
  {
    name: "newsletter-completed___es",
    path: "/es/newsletter/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue")
  },
  {
    name: "newsletter-completed___fr",
    path: "/fr/newsletter/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue")
  },
  {
    name: "newsletter-completed___it",
    path: "/it/newsletter/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue")
  },
  {
    name: "newsletter-completed___ru",
    path: "/ru/newsletter/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue")
  },
  {
    name: "newsletter-completed___de",
    path: "/de/newsletter/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue")
  },
  {
    name: "newsletter-completed___pl",
    path: "/pl/newsletter/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/completed.vue")
  },
  {
    name: "pages-shipping-prices___en",
    path: "/en/pages/shipping-prices",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue")
  },
  {
    name: "pages-shipping-prices___es",
    path: "/es/paginas/precios-de-envio",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue")
  },
  {
    name: "pages-shipping-prices___fr",
    path: "/fr/pages/tarifs-d-expedition",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue")
  },
  {
    name: "pages-shipping-prices___it",
    path: "/it/pagine/prezzi-di-spedizione",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue")
  },
  {
    name: "pages-shipping-prices___ru",
    path: "/ru/pages/shipping-prices",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue")
  },
  {
    name: "pages-shipping-prices___de",
    path: "/de/seiten/versandpreise",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue")
  },
  {
    name: "pages-shipping-prices___pl",
    path: "/pl/strony/ceny-wysylki",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/pages/shipping-prices.vue")
  },
  {
    name: "register-verify___en",
    path: "/en/register/verify",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue")
  },
  {
    name: "register-verify___es",
    path: "/es/registro/verificar",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue")
  },
  {
    name: "register-verify___fr",
    path: "/fr/inscription/verifier",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue")
  },
  {
    name: "register-verify___it",
    path: "/it/registrazione/verifica",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue")
  },
  {
    name: "register-verify___ru",
    path: "/ru/register/verify",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue")
  },
  {
    name: "register-verify___de",
    path: "/de/registrieren/verifizieren",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue")
  },
  {
    name: "register-verify___pl",
    path: "/pl/rejestracja/weryfikacja",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/index.vue")
  },
  {
    name: "reset-password-code___en",
    path: "/en/reset-password/:code()",
    meta: { ...(_91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta || {}), ...{"middleware":"page-forgot-password"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue")
  },
  {
    name: "reset-password-code___es",
    path: "/es/restablecer-contrasena/:code()",
    meta: { ...(_91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta || {}), ...{"middleware":"page-forgot-password"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue")
  },
  {
    name: "reset-password-code___fr",
    path: "/fr/reinitialiser-mot-de-passe/:code()",
    meta: { ...(_91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta || {}), ...{"middleware":"page-forgot-password"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue")
  },
  {
    name: "reset-password-code___it",
    path: "/it/reimposta-password/:code()",
    meta: { ...(_91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta || {}), ...{"middleware":"page-forgot-password"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue")
  },
  {
    name: "reset-password-code___ru",
    path: "/ru/reset-password/:code()",
    meta: { ...(_91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta || {}), ...{"middleware":"page-forgot-password"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue")
  },
  {
    name: "reset-password-code___de",
    path: "/de/passwort-zuruecksetzen/:code()",
    meta: { ...(_91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta || {}), ...{"middleware":"page-forgot-password"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue")
  },
  {
    name: "reset-password-code___pl",
    path: "/pl/zresetuj-haslo/:code()",
    meta: { ...(_91code_93NFhIiBpaF1s0d7EJkKxHd5wTCNQ8L0y_sNLdOXF92yUMeta || {}), ...{"middleware":"page-forgot-password"} },
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/reset-password/[code].vue")
  },
  {
    name: "subaccounts-completed___en",
    path: "/en/subaccounts/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue")
  },
  {
    name: "subaccounts-completed___es",
    path: "/es/subaccounts/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue")
  },
  {
    name: "subaccounts-completed___fr",
    path: "/fr/subaccounts/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue")
  },
  {
    name: "subaccounts-completed___it",
    path: "/it/subaccounts/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue")
  },
  {
    name: "subaccounts-completed___ru",
    path: "/ru/subaccounts/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue")
  },
  {
    name: "subaccounts-completed___de",
    path: "/de/subaccounts/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue")
  },
  {
    name: "subaccounts-completed___pl",
    path: "/pl/subaccounts/completed",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/subaccounts/completed.vue")
  },
  {
    name: "newsletter-unsubscribe___en",
    path: "/en/newsletter/unsubscribe",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue")
  },
  {
    name: "newsletter-unsubscribe___es",
    path: "/es/newsletter/unsubscribe",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue")
  },
  {
    name: "newsletter-unsubscribe___fr",
    path: "/fr/newsletter/unsubscribe",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue")
  },
  {
    name: "newsletter-unsubscribe___it",
    path: "/it/newsletter/unsubscribe",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue")
  },
  {
    name: "newsletter-unsubscribe___ru",
    path: "/ru/newsletter/unsubscribe",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue")
  },
  {
    name: "newsletter-unsubscribe___de",
    path: "/de/newsletter/unsubscribe",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue")
  },
  {
    name: "newsletter-unsubscribe___pl",
    path: "/pl/newsletter/unsubscribe",
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/newsletter/unsubscribe.vue")
  },
  {
    name: "register-verify-code___en",
    path: "/en/register/verify/:code()",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue")
  },
  {
    name: "register-verify-code___es",
    path: "/es/registro/verificar/:code()",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue")
  },
  {
    name: "register-verify-code___fr",
    path: "/fr/inscription/verifier/:code()",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue")
  },
  {
    name: "register-verify-code___it",
    path: "/it/registrazione/verifica/:code()",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue")
  },
  {
    name: "register-verify-code___ru",
    path: "/ru/register/verify/:code()",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue")
  },
  {
    name: "register-verify-code___de",
    path: "/de/registrieren/verifizieren/:code()",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue")
  },
  {
    name: "register-verify-code___pl",
    path: "/pl/rejestracja/weryfikacja/:code()",
    meta: {"middleware":["guest","page-register-verify"]},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/register/verify/[code].vue")
  },
  {
    name: "charts-code-weight___en",
    path: "/en/charts/:code()/:weight()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue")
  },
  {
    name: "charts-code-weight___es",
    path: "/es/graficos/:code()/:weight()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue")
  },
  {
    name: "charts-code-weight___fr",
    path: "/fr/graphiques/:code()/:weight()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue")
  },
  {
    name: "charts-code-weight___it",
    path: "/it/grafici/:code()/:weight()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue")
  },
  {
    name: "charts-code-weight___ru",
    path: "/ru/charts/:code()/:weight()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue")
  },
  {
    name: "charts-code-weight___de",
    path: "/de/kurse/:code()/:weight()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue")
  },
  {
    name: "charts-code-weight___pl",
    path: "/pl/wykresy/:code()/:weight()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/index.vue")
  },
  {
    name: "charts-code-weight-period___en",
    path: "/en/charts/:code()/:weight()/:period()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue")
  },
  {
    name: "charts-code-weight-period___es",
    path: "/es/graficos/:code()/:weight()/:period()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue")
  },
  {
    name: "charts-code-weight-period___fr",
    path: "/fr/graphiques/:code()/:weight()/:period()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue")
  },
  {
    name: "charts-code-weight-period___it",
    path: "/it/grafici/:code()/:weight()/:period()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue")
  },
  {
    name: "charts-code-weight-period___ru",
    path: "/ru/charts/:code()/:weight()/:period()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue")
  },
  {
    name: "charts-code-weight-period___de",
    path: "/de/kurse/:code()/:weight()/:period()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue")
  },
  {
    name: "charts-code-weight-period___pl",
    path: "/pl/wykresy/:code()/:weight()/:period()",
    meta: {"middleware":"page-charts"},
    component: () => import("/usr/src/nuxtapp/app/pages/sbe/charts/[code]/[weight]/[period]/index.vue")
  },
  {
    name: "trade-sell___en",
    path: "/en/trade/sell",
    meta: { ...(index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/index.vue")
  },
  {
    name: "trade-sell___es",
    path: "/es/trade/sell",
    meta: { ...(index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/index.vue")
  },
  {
    name: "trade-sell___fr",
    path: "/fr/trade/sell",
    meta: { ...(index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/index.vue")
  },
  {
    name: "trade-sell___it",
    path: "/it/trade/sell",
    meta: { ...(index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/index.vue")
  },
  {
    name: "trade-sell___ru",
    path: "/ru/trade/sell",
    meta: { ...(index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/index.vue")
  },
  {
    name: "trade-sell___de",
    path: "/de/trade/sell",
    meta: { ...(index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/index.vue")
  },
  {
    name: "trade-sell___pl",
    path: "/pl/trade/sell",
    meta: { ...(index66590zsO46SKcFlGIOL_VOXfe6Fioer5G7JLuNl3H5UMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/index.vue")
  },
  {
    name: "trade-review___en",
    path: "/en/trade/review",
    meta: { ...(reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/review.vue")
  },
  {
    name: "trade-review___es",
    path: "/es/trade/review",
    meta: { ...(reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/review.vue")
  },
  {
    name: "trade-review___fr",
    path: "/fr/trade/review",
    meta: { ...(reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/review.vue")
  },
  {
    name: "trade-review___it",
    path: "/it/trade/review",
    meta: { ...(reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/review.vue")
  },
  {
    name: "trade-review___ru",
    path: "/ru/trade/review",
    meta: { ...(reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/review.vue")
  },
  {
    name: "trade-review___de",
    path: "/de/trade/review",
    meta: { ...(reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/review.vue")
  },
  {
    name: "trade-review___pl",
    path: "/pl/trade/review",
    meta: { ...(reviewIMYv_rSJ4KUi9zsp0b9yvGrO4qESi5N6dPqWtJJl4sQMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/review.vue")
  },
  {
    name: "trade-sell-review___en",
    path: "/en/trade/sell/review",
    meta: { ...(review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/review.vue")
  },
  {
    name: "trade-sell-review___es",
    path: "/es/trade/sell/review",
    meta: { ...(review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/review.vue")
  },
  {
    name: "trade-sell-review___fr",
    path: "/fr/trade/sell/review",
    meta: { ...(review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/review.vue")
  },
  {
    name: "trade-sell-review___it",
    path: "/it/trade/sell/review",
    meta: { ...(review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/review.vue")
  },
  {
    name: "trade-sell-review___ru",
    path: "/ru/trade/sell/review",
    meta: { ...(review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/review.vue")
  },
  {
    name: "trade-sell-review___de",
    path: "/de/trade/sell/review",
    meta: { ...(review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/review.vue")
  },
  {
    name: "trade-sell-review___pl",
    path: "/pl/trade/sell/review",
    meta: { ...(review3xi3rcHwAOsaj_iJ8X4dwz250IyPn36DrY71w3MrZ0sMeta || {}), ...{"middleware":["permission","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/review.vue")
  },
  {
    name: "trade-complete___en",
    path: "/en/trade/complete",
    meta: { ...(completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta || {}), ...{"middleware":["permission","page-trade-complete"]} },
    component: () => import("~/pages/spm/trade/complete.vue")
  },
  {
    name: "trade-complete___es",
    path: "/es/trade/complete",
    meta: { ...(completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta || {}), ...{"middleware":["permission","page-trade-complete"]} },
    component: () => import("~/pages/spm/trade/complete.vue")
  },
  {
    name: "trade-complete___fr",
    path: "/fr/trade/complete",
    meta: { ...(completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta || {}), ...{"middleware":["permission","page-trade-complete"]} },
    component: () => import("~/pages/spm/trade/complete.vue")
  },
  {
    name: "trade-complete___it",
    path: "/it/trade/complete",
    meta: { ...(completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta || {}), ...{"middleware":["permission","page-trade-complete"]} },
    component: () => import("~/pages/spm/trade/complete.vue")
  },
  {
    name: "trade-complete___ru",
    path: "/ru/trade/complete",
    meta: { ...(completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta || {}), ...{"middleware":["permission","page-trade-complete"]} },
    component: () => import("~/pages/spm/trade/complete.vue")
  },
  {
    name: "trade-complete___de",
    path: "/de/trade/complete",
    meta: { ...(completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta || {}), ...{"middleware":["permission","page-trade-complete"]} },
    component: () => import("~/pages/spm/trade/complete.vue")
  },
  {
    name: "trade-complete___pl",
    path: "/pl/trade/complete",
    meta: { ...(completeQPx4AruEVbl2SdrqKdYRxkaX4TkJk2UJ_10_emIadm0Meta || {}), ...{"middleware":["permission","page-trade-complete"]} },
    component: () => import("~/pages/spm/trade/complete.vue")
  },
  {
    name: "trade-sell-complete___en",
    path: "/en/trade/sell/complete",
    meta: { ...(completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta || {}), ...{"middleware":["permission","page-trade-complete","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/complete.vue")
  },
  {
    name: "trade-sell-complete___es",
    path: "/es/trade/sell/complete",
    meta: { ...(completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta || {}), ...{"middleware":["permission","page-trade-complete","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/complete.vue")
  },
  {
    name: "trade-sell-complete___fr",
    path: "/fr/trade/sell/complete",
    meta: { ...(completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta || {}), ...{"middleware":["permission","page-trade-complete","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/complete.vue")
  },
  {
    name: "trade-sell-complete___it",
    path: "/it/trade/sell/complete",
    meta: { ...(completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta || {}), ...{"middleware":["permission","page-trade-complete","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/complete.vue")
  },
  {
    name: "trade-sell-complete___ru",
    path: "/ru/trade/sell/complete",
    meta: { ...(completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta || {}), ...{"middleware":["permission","page-trade-complete","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/complete.vue")
  },
  {
    name: "trade-sell-complete___de",
    path: "/de/trade/sell/complete",
    meta: { ...(completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta || {}), ...{"middleware":["permission","page-trade-complete","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/complete.vue")
  },
  {
    name: "trade-sell-complete___pl",
    path: "/pl/trade/sell/complete",
    meta: { ...(completez8TMOeXi1nW9_qCMQO1yxsvIQndbnHpF31CFKLo4sukMeta || {}), ...{"middleware":["permission","page-trade-complete","page-trade"]} },
    component: () => import("~/pages/spm/trade/sell/complete.vue")
  }
]